import { type Maybe } from './maybe';

type LabelResolver<T> = (item: T) => Maybe<string>;
type ChildrenResolver<T> = (item: T) => Maybe<T[]>;

export function getLabelText(value: unknown, labelKey?: string): Maybe<string> {
    if (value === null || typeof value === 'undefined') {
        return null;
    }

    if (typeof value === 'string' || typeof value === 'number') {
        return String(value);
    }

    if (!labelKey || typeof value !== 'object') {
        return null;
    }

    const resolvedValue = (value as Record<string, unknown>)[labelKey];

    if (
        typeof resolvedValue === 'string' ||
        typeof resolvedValue === 'number'
    ) {
        return String(resolvedValue);
    }

    return null;
}

export function isPlainLabelList<T>(
    items: Maybe<T[]>,
    getLabel: LabelResolver<T>,
): boolean {
    if (!Array.isArray(items) || items.length === 0) {
        return false;
    }

    return items.every((item) => getLabel(item) !== null);
}

export function isPlainLabelTree<T>(
    items: Maybe<T[]>,
    getLabel: LabelResolver<T>,
    getChildren: ChildrenResolver<T>,
): boolean {
    if (!Array.isArray(items) || items.length === 0) {
        return false;
    }

    return items.every((item) => {
        const children = getChildren(item);

        return (
            getLabel(item) !== null &&
            (!children?.length ||
                isPlainLabelTree(children, getLabel, getChildren))
        );
    });
}
